import React from 'react'
import moment from 'moment'
import { Heading, Note } from '@myxplor/ui'
import { name } from './helpers'

import ApproveButton from './approve-button'

const Approved = ({ agreed_at, parent }) => (
  <Note important>
    <Heading small>
      This was agreed on {moment(agreed_at, 'YYYY-MM-DD').format('Do MMM YYYY')} by {name(parent)}
    </Heading>
  </Note>
)

const NotAllowed = () => (
  <Note important>
    <Heading small>This agreement has not been signed</Heading>
    You are not allowed to sign this agreement
  </Note>
)

const ApprovalSection = ({
  data,
  care_id,
  parent_id,
  refresh_parent_agreement,
  parent,
  can_sign,
}) => {
  return (
    <div className="ApprovalSection">
      {data.status === 'approved' ? (
        <Approved agreed_at={data.agreed_at} parent={parent} />
      ) : can_sign ? (
        <ApproveButton
          care_id={care_id}
          parent_id={parent_id}
          record={data}
          refresh_parent_agreement={refresh_parent_agreement}
        />
      ) : (
            <NotAllowed />
          )}
    </div>
  )
}

export default ApprovalSection



// WEBPACK FOOTER //
// ./src/parent-agreement/views/ApprovalSection.jsx